import { categories } from "@/mocks/anime";

export default function Hero() {
  return (
    <section
      id="home"
      className="relative flex min-h-[640px] w-full items-center justify-center overflow-hidden bg-cover bg-center pt-16"
      style={{
        backgroundImage:
          "url(https://readdy.ai/api/search-image?query=Adorable%20anime%20dog%20and%20anthropomorphic%20animal%20friends%20gathering%20on%20a%20warm%20sunny%20meadow%2C%20cheerful%20playful%20group%20of%20corgi%20shiba%20fox%20kitten%20characters%2C%20warm%20golden%20orange%20and%20cream%20palette%2C%20soft%20cinematic%20lighting%2C%20stylish%20anime%20illustration%2C%20joyful%20cozy%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=xg-hero-2026&orientation=landscape)",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 text-center">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/30 bg-background-50/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur-sm">
          <i className="ri-heart-3-fill text-accent-500"></i>
          萌宠控的专属番剧宇宙
        </span>

        <h1 className="mt-6 font-heading text-4xl md:text-6xl leading-tight text-background-50">
          小狗看番
        </h1>
        <p className="mt-4 text-base md:text-xl text-background-50/90 leading-relaxed">
          狗狗主角动画 · 动物拟人番 · 兽耳萌番 · 宠物日常，按人气排序，
          每部附主角设定简介，点开就能找到合口味的番。
        </p>

        <div className="mx-auto mt-8 flex max-w-xl items-center gap-2 rounded-full border border-background-50/30 bg-background-50/15 p-1.5 backdrop-blur-md">
          <i className="ri-search-line pl-3 text-lg text-background-50/80"></i>
          <input
            type="text"
            placeholder="搜一部想看的萌宠番…"
            className="w-full bg-transparent text-sm text-background-50 placeholder:text-background-50/60 focus:outline-none"
          />
          <button
            type="button"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            搜索
          </button>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {categories.slice(0, 4).map((c) => (
            <a
              key={c.id}
              href="#category"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-sm text-background-50 hover:bg-background-50/20 transition-colors"
            >
              <i className={c.icon}></i>
              {c.name}
            </a>
          ))}
        </div>
      </div>

      <a
        href="#hot"
        aria-label="向下滚动"
        className="absolute bottom-6 left-1/2 -translate-x-1/2 flex h-10 w-10 items-center justify-center rounded-full border border-background-50/30 text-background-50 animate-bounce hover:bg-background-50/15 transition-colors"
      >
        <i className="ri-arrow-down-s-line text-xl"></i>
      </a>
    </section>
  );
}